import { useMutation, useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { OrganizationsResponses } from "@tfg/types/endpoints/organizations"
import {
  SupplierGetQueryValidationType,
  supplierMonitoringFiltersValidationType,
} from "@tfg/types/schemas/organization/schemas"

import { httpClient } from "~/backend/axios.ts"

export const useDownloadSuppliersCSVMutation = ({
  searchSupplier,
  filters,
}: Omit<SupplierGetQueryValidationType, "filters"> & {
  filters: supplierMonitoringFiltersValidationType
}) => {
  return useMutation<void, AxiosError>({
    mutationKey: ["suppliers", "download-csv", searchSupplier, filters],

    mutationFn: async () => {
      const response = await httpClient.get("suppliers/export-suppliers", {
        responseType: "blob",
        params: {
          searchSupplier,
          filters: JSON.stringify(filters),
        },
      })

      // anchor link
      const element = document.createElement("a")
      element.href = URL.createObjectURL(new Blob([response.data]))
      element.download = "suppliers.csv"

      // simulate link click
      document.body.appendChild(element) // Required for this to work in FireFox
      element.click()
    },
  })
}

export const useDownloadSuppliersProdSitesCSVMutation = ({
  searchProductionSite,
}: {
  searchProductionSite: string
}) => {
  return useMutation<void, AxiosError>({
    mutationKey: ["suppliers", "download-csv", searchProductionSite],

    mutationFn: async () => {
      const response = await httpClient.get("suppliers/export-prod-sites", {
        responseType: "blob",
        params: {
          searchProductionSite,
        },
      })

      // anchor link
      const element = document.createElement("a")
      element.href = URL.createObjectURL(new Blob([response.data]))
      element.download = "production-sites.csv"

      // simulate link click
      document.body.appendChild(element) // Required for this to work in FireFox
      element.click()
    },
  })
}

export const useListOrganizationContactsQuery = () => {
  return useQuery({
    queryKey: ["organizationId", "contacts"],

    queryFn: async () => {
      const response = await httpClient.get<OrganizationsResponses.Contact[]>(
        `organizations/contacts`
      )
      return response.data
    },
  })
}
